import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import unplannedSubtasksFor from './unplannedSubtasksFor'

/**
 * De nog in te plannen klussen van één huishouden, eenmalig gelezen — voor de
 * voorgestelde duur van een nieuw bezoek op een plek zonder listener op de
 * subtaken (slepen in de agenda, een vervolgbezoek, de afspraakbewerker).
 *
 * Draagt `CompagnyID`; `Deleted` en de rest filtert `unplannedSubtasksFor`.
 * AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch
 *
 * @param {string} [adressId] - `Adresses.ID`
 * @returns {Promise<Array<object>>} Op Position, met `docid`; leeg zonder huishouden
 */
const fetchHouseholdSubtasks = async (adressId) => {
    if (!adressId || !client) return []

    const snap = await db.collection('Tasks')
        .where('CompagnyID', '==', client)
        .where('AdressID', '==', adressId)
        .get()

    return unplannedSubtasksFor(snap.docs.map((doc) => ({ ...doc.data(), docid: doc.id })), adressId)
}

export default fetchHouseholdSubtasks
